/* eslint-disable max-lines-per-function */
import { Asset, MultiLink } from '../types';
import React, { JSX, useEffect } from 'react';
import { ComponentWithContentProps, GenericSBProps } from '../types';
import RichText from '../richtext';
import { Alignment, VerticalAlignment } from '../../utils/data-source';
import Styles from './table.module.scss';
import Tooltip from '../ToolTip/ToolTip';
import Row from '../ResponsiveRow/row';
import { trackComponent } from '../../utils/AnalyticsUtils';
import { CONTENT, TABLE, TEXT } from '../../Analytics/AnalyticsConstants';

export interface TableSchema extends GenericSBProps {
  tableBlock: TableBlokSchema[];
}
interface TableBlokSchema {
  tableHeading: string[];
  tableRows: TableObject[];
  tableBorder: string;
}
interface TableObject {
  text?: string;
  tableIcon?: Asset | undefined;
  link?: MultiLink;
  verticalAlignment?: VerticalAlignment;
  horizontalAlignment?: Alignment;
  toolTipText?: any;
}

const Table = ({ content }: ComponentWithContentProps<TableSchema>): JSX.Element => {
  useEffect(() => {
    trackComponent(TABLE, '', CONTENT, TEXT);
  }, [content]);
  const tableData = (item: any) => {
    if (item.text) {
      return item.text;
    } else if (item.description) {
      return <RichText content={item.description} />;
    } else if (item.tableIcon.length > 0) {
      return item.tableIcon.map((iconItem: any) => (
        <img
          src={iconItem.image?.filename}
          height={iconItem.imageHeight ? iconItem.imageHeight + 'px' : '32px'}
          width={iconItem.imageWidth ? iconItem.imageWidth + 'px' : '32px'}
          alt='icon'
        ></img>
      ));
    } else {
      return;
    }
  };
  const toolTip = (toolTipItem: any) => {
    if (toolTipItem?.length > 0) {
      return <Tooltip content={toolTipItem} />;
    }
    return '';
  };
  const displayData = (item: any) => {
    if (item) {
      return item.tableIcon.length > 1 ? (
        <span
          className={`${item.tableIcon.length > 1 ? Styles['image'] : ''}
                ${
                  item.verticalAlignment === 'top'
                    ? Styles['vertical-top-align']
                    : item.verticalAlignment === 'bottom'
                    ? Styles['vertical-bottom-align']
                    : Styles['vertical-center-align']
                }  
                ${
                  item.horizontalAlignment === 'left'
                    ? Styles['horizontal-top-align']
                    : item.horizontalAlignment === 'right'
                    ? Styles['horizontal-bottom-align']
                    : Styles['horizontal-center-align']
                }
                `}
        >
          {' '}
          {tableData(item)}
        </span>
      ) : (
        tableData(item)
      );
    }
  };
  return (
      <Row>
        {content.tableBlock && (
          <>
            {/* <div className={`table-comp1 ${Styles['table-comp1']}`}>
                <div className={`${Styles['table-scroll']}`}>
                </div>
            </div> */}
            <div className={`table-comp ${Styles['table-comp']}`}>
              <table className={`table ${Styles['table']}`}>
                <thead>
                <tr>
                  {content.tableBlock.map(
                    (blockItem: TableBlokSchema) =>
                      blockItem.tableHeading &&
                      blockItem.tableHeading.map((headeritem: any) => (
                        <th
                          className={`${
                            headeritem.verticalAlignment === 'top'
                              ? Styles['vertical-top-align']
                              : headeritem.verticalAlignment === 'bottom'
                              ? Styles['vertical-bottom-align']
                              : Styles['vertical-center-align']
                          }
                            ${
                              headeritem.horizontalAlignment === 'left'
                                ? Styles['horizontal-top-align']
                                : headeritem.horizontalAlignment === 'right'
                                ? Styles['horizontal-bottom-align']
                                : Styles['horizontal-center-align']
                            }
                            ${
                              blockItem.tableBorder === 'dotted'
                                ? Styles['dotted']
                                : blockItem.tableBorder === 'bold'
                                ? Styles['bold']
                                : blockItem.tableBorder === 'thin'
                                ? Styles['thin']
                                : Styles['no-border']
                            }
                            `}
                        >
                          {headeritem.headerText}
                        </th>
                      ))
                  )}
                </tr>
                </thead>
                <tbody>
                <tr></tr>
                {content.tableBlock?.map((blockItem: TableBlokSchema) =>
                  blockItem.tableRows?.map((rowitems: any) => (
                    <tr>
                      {rowitems.rowBlock?.map((item: TableObject | any) => (
                        <td
                          className={`${
                            item.verticalAlignment === 'top'
                              ? Styles['vertical-top-align']
                              : item.verticalAlignment === 'bottom'
                              ? Styles['vertical-bottom-align']
                              : Styles['vertical-center-align']
                          }  
                                ${
                                  item.horizontalAlignment === 'left'
                                    ? Styles['horizontal-top-align']
                                    : item.horizontalAlignment === 'right'
                                    ? Styles['horizontal-bottom-align']
                                    : Styles['horizontal-center-align']
                                }
                                ${
                                  blockItem.tableBorder === 'dotted'
                                    ? Styles['dotted']
                                    : blockItem.tableBorder === 'bold'
                                    ? Styles['bold']
                                    : blockItem.tableBorder === 'thin'
                                    ? Styles['thin']
                                    : Styles['no-border']
                                }
                                `}
                        >
                          {item.toolTipText?.length > 0 ? (
                            <div
                              className={`${
                                item.verticalAlignment === 'top'
                                  ? Styles['vertical-top-align']
                                  : item.verticalAlignment === 'bottom'
                                  ? Styles['vertical-bottom-align']
                                  : Styles['vertical-center-align']
                              }  
                                    ${
                                      item.horizontalAlignment === 'left'
                                        ? Styles['horizontal-top-align']
                                        : item.horizontalAlignment === 'right'
                                        ? Styles['horizontal-bottom-align']
                                        : Styles['horizontal-center-align']
                                    }
                                    `}
                              style={{ display: 'flex' }}
                            >
                              {displayData(item)}
                              {toolTip(item.toolTipText)}
                            </div>
                          ) : (
                            displayData(item)
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </Row>
  );
};
export default Table;
